import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { IMeeting } from '../../../../../app/resource/meeting/meeting.types';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { IMeetingShortcut } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import {
  meetingFilesSelectedSelectors,
  meetingFilesSelectors,
} from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';
import { MeetingsShortcutsRow } from './MeetingsShortcutsRow';

export const MeetingsShortcutsList: FunctionComponent = () => {
  const { meetingId } = useParams<{ meetingId: IMeeting['id'] }>();

  const foldersSelectedFilesIds = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceIds, meetingId);
  const [foldersSelectedFiles] = useSelectWithParams(
    meetingFilesSelectors.selectResourcesById,
    foldersSelectedFilesIds,
  );

  return (
    <>
      <div className="table-container files-table" role="table" aria-label="Destinations">
        <div className="flex-table header panel mb-1 aic py-0" role="rowgroup">
          <div className="flex-row" role="columnheader">
            SHORTCUT
          </div>
          <div className="flex-row" role="columnheader">
            UPLOADED BY
          </div>
          <div className="flex-row wide" role="columnheader">
            DESCRIPTION
          </div>
          <div className="flex-row" role="columnheader"></div>
        </div>
        {foldersSelectedFiles?.files && foldersSelectedFiles.files.length > 0 ? (
          foldersSelectedFiles.files.map((file: IMeetingShortcut) => (
            <MeetingsShortcutsRow shortcut={file} meetingId={meetingId} key={file.id} />
          ))
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p>No files available in this folder.</p>
          </div>
        )}
      </div>
      {/* PAGINATION */}
      {/*    <div className="flex-table header panel mb-1 aic py-0" role="rowgroup">
                    <div className="flex-row full" role="columnheader">
                      <div className="table-pagination">
                        <span className="prev">
                          <i className="icon2-slider-left"></i>
                        </span>
                        <span className="page-num">1</span>
                        <span className="page-num current">2</span>
                        <span className="page-num">3</span>
                        <span className="page-num">4</span>
                        <span className="page-num">5</span>
                        <span className="next">
                          <i className="icon2-slider-right"></i>
                        </span>
                      </div>
                    </div>
                  </div> */}
    </>
  );
};
